import { Box, Divider, Paper, Stack, Typography } from '@mui/material'
import { FC, Fragment } from 'react'

import { ServiceExpanded, ServiceInfoStatusEnum } from '../../sdk'
import { formatCurrency } from '../../utils'

interface Props {
  services: ServiceExpanded[]
  showPrice: boolean
}

const ServicesSummaryPanel: FC<Props> = ({ services, showPrice }) => {
  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Typography variant="h4" marginBottom={1}>
        Services
      </Typography>
      <Stack spacing={2}>
        {[
          ServiceInfoStatusEnum.Authorized,
          ServiceInfoStatusEnum.Recommended,
          ServiceInfoStatusEnum.Deferred
        ].map((status) => {
          const filteredServices = services.filter(
            (s) => s.entry!.info!.status === status
          )
          return filteredServices.length > 0 ? (
            <Stack spacing={1} key={status}>
              <Typography variant="subtitle1">{status}</Typography>
              {filteredServices.map((service) => (
                <Box key={service.entry!.id}>
                  <Stack direction="row" justifyContent={'space-between'}>
                    <Typography variant="body2">
                      {service.entry!.info!.title}
                    </Typography>
                    <Typography variant="body2">
                      {showPrice &&
                        formatCurrency(service.cachedRetailPrice!, true)}
                    </Typography>
                  </Stack>
                  <Divider />
                </Box>
              ))}
            </Stack>
          ) : (
            <Fragment key={status}></Fragment>
          )
        })}
      </Stack>
    </Paper>
  )
}

export default ServicesSummaryPanel
